import React, { useMemo } from 'react';
import { codigoEmpresaSchema } from '../../../services/validators';
import { useParams } from 'react-router-dom';
import Loading from '../../../components/globales/Loading';
import TablaLayout from '../../../components/globales/TablaLayout';
import ModalDynamic from '../../../components/globales/ModalDynamic';
import useCrud from '../../../hooks/useCrud';
import ENDPOINTS from '../../../api/endpoints';

export default function EmpresasCodigo() {
    const { id } = useParams();
    const keyField = 'id_codigo_empresa'; 

    const codigosEndpoints = useMemo(() => ({
        listar: ENDPOINTS.empresasCodigos.listar(id),
        crear: ENDPOINTS.empresasCodigos.crear,
        actualizar: ENDPOINTS.empresasCodigos.actualizar,
        borrar: ENDPOINTS.empresasCodigos.borrar
    }), [id]);

    const initForm = () => ({
        codigo: '',
        id_empresa: parseInt(id, 10)
    });

    const columns = [
        { label: 'No', key: 'index', align: 'center', render: (_, i) => i + 1 },
        { label: 'Código', key: 'codigo', width: 'auto' }
    ];

    const breadcrumbs = [
        { label: 'Inicio', href: '/inicio' },
        { label: 'Empresas', href: '/empresas' },
        { label: 'Códigos' }
    ];
    const {
        data,
        loading,
        error,
        showModal,
        actionType,
        formData,
        errors,
        openModal,
        closeModal,
        handleChange,
        submit,
        remove
    } = useCrud(codigosEndpoints, { keyField, initForm, columns, schema: codigoEmpresaSchema });
    
    if (loading) return <Loading mensaje="Cargando Códigos…" />;
    if (error) return <div className="text-danger">Error: {error.message}</div>;

    return (
        <div className="container">
            <TablaLayout
                title="Códigos"
                data={data}
                columns={columns}
                keyField={keyField}
                onCreate={() => openModal('crear')}
                onView={item => openModal('consultar', item)}
                onEdit={item => openModal('editar', item)}
                onDelete={remove}
                showConsult={false}
                breadcrumbs={breadcrumbs}
            />

            <ModalDynamic
                show={showModal}
                accion={actionType}
                title="Código"
                columns={columns}
                formData={formData}
                errors={errors}
                onChange={handleChange}
                onSubmit={submit}
                onClose={closeModal}
            />
        </div>
    );
}
